import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

// todo: check for duplicates
@Directive({
    selector: '[sbClickOutside]',
})
export class ClickOutsideDirective {
    constructor(private _elementRef: ElementRef) {}

    @Output() sbClickOutside = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);

        if (!clickedInside) {
            this.sbClickOutside.emit(null);
        }
    }
}
